namespace $.$$ {
	
	$mol_style_define( $giper_baza_flex_form, {
		
		gap: $mol_gap.block,
		
		Field: {
			
			background: {
				color: $mol_theme.card,
			},
			
			border: {
				radius: $mol_gap.round,
			},
			
			Trigger: {
				Icon: {
					margin: 0,
				},
			},
			
		},
		
	} )
	
}
